<template>
  <div class="aha-footer">
    <div
      class="aha-footer__live-chat"
      :class="{'d-none': !isAudienceEmojiDisabled}"
      v-if="isLiveChatVisible"
    >
      <LiveChat class="live-chat__wrapper" :openByDefault="isChatOpenByDefault" />
    </div>

    <template v-if="isPoweredByShowing && !isCtaShowing">
      <div class="powered-by">
        <a
          :href="poweredByURL"
          target="_blank"
          class="mr-3"
          @click="trackPoweredByGAEvent"
        >{{ $t("powerBy") }}</a>

        <a :href="termsURL" target="_blank" @click="trackTermsGAEvent">{{ $t("term") }}</a>
      </div>
    </template>

    <AudienceCTA v-if="isCtaShowing && !isSkoleTube" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

// constants
import QuizStatuses from '@/constants/QuizStatuses'

// containers
import AudienceCTAContainer from '@/containers/footer/AudienceCTA'

// components
import AudienceCTA from '@/components/footer/AudienceCTA.vue'
import LiveChat from '@/components/common/LiveChat.vue'

// utils
import Util from '@/util'

export default {
  components: {
    AudienceCTA: AudienceCTAContainer(AudienceCTA),
    LiveChat,
  },
  props: {
    isCtaShowing: {
      type: Boolean,
      default: false,
    },
    isPoweredByShowing: {
      type: Boolean,
      default: false,
    },
    poweredByURL: {
      type: String,
      default: '',
    },
    termsURL: {
      type: String,
      default: '',
    },
    trackTermsGAEvent: {
      type: Function,
      default: () => {},
    },
    trackPoweredByGAEvent: {
      type: Function,
      default: () => {},
    },
    isWhiteLabelUser: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slide,
      audienceName: (state) => state.audienceName,
      audienceId: (state) => state.audienceId,
      audienceTeam: (state) => {
        return state.presentation.teamData ?
          state.presentation.teamData.find((team) => team.id === state.audienceQuizTeam) : {}
      },
      isAudienceEmojiDisabled: (state) => state.isAudienceEmojiDisabled,
      isPresenting: (state) => state.presentation.presenting,
    }),

    isQuizSlide() {
      return this.slideActive.type === 'pickAnswer' &&
      (this.slideActive.quizStatus === QuizStatuses.LOBBY_SCREEN
      || this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN)
    },

    hasAudienceInfo() {
      const hasSoloInfo = this.audienceName.length !== 0 && this.audienceId
      if (this.presentation.teamPlay && this.audienceTeam && this.audienceTeam.name) {
        return this.audienceTeam.name.length !== 0 && hasSoloInfo
      }
      return hasSoloInfo
    },

    isLiveChatVisible() {
      return this.presentation.isEnableChat &&
        !this.presentation.audiencePacing &&
        !this.presentation.privateMode &&
        !Util.enableAudienceAdmissionForm() &&
        this.hasAudienceInfo &&
        this.isPresenting &&
        (this.isQuizSlide ||
        this.slideActive.type === 'leaderboard' ||
        this.canShowChatOnQRSlide)
    },

    hasQuizSlides() {
      return this.$store.state.slides &&
          this.$store.state.slides.length > 0 &&
          this.$store.state.slides.some((slide) => slide.type === 'pickAnswer')
    },

    canShowChatOnQRSlide() {
      return this.slideActive.type === 'qrcode' && this.hasQuizSlides
    },

    isTextColourLight() {
      return this.slideActive.textColour === '#ffffff'
    },

    isChatOpenByDefault() {
      const { type, quizStatus } = this.slideActive
      return (type === 'pickAnswer' &&
        quizStatus === QuizStatuses.LOBBY_SCREEN) ||
        type === 'qrcode'
    },
    isSkoleTube() {
      try {
        const { identifyProvider } = this.presentation.user
        return identifyProvider === 'skoletube'
      } catch {
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.aha-footer__live-chat{
  position: fixed;
  right: 1rem;
  bottom: 0.5rem;
  z-index: 100;
}

.live-chat__wrapper {
  position: absolute;
  right: 1rem;
  bottom: 0;
  z-index: 10;
  & ::v-deep {
    .chat-box__tip {
      top: -19px;
      right: 2.5rem;
      left: unset;
    }
    .chat-box__header-close-icon {
      margin-top: 8px;
    }
  }
}

@media (max-width: 767px) {
  .live-chat__wrapper {
    right: 0.5rem;
  & ::v-deep {
      .chat-toggle__title {
        display: none;
      }
      .chat-box__tip {
        right: 0.5rem;
        top: -20px;
      }
      .chat-toggle--pill {
        padding: 7px 9px 4px 13px;
      }
    }
  }
}

.aha-footer {
  width: 100%;
  box-sizing: border-box;
}

.powered-by {
  display: flex;
  justify-content: center;
  padding: 12px;
  font-size: 14px;
  color: inherit;

  a {
    color: inherit;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
